@let wizardHost = wizard();
@let ticketInfo = ticket();
<div class="relative flex w-full min-w-0 flex-col gap-4">
  <p class="text-sm font-semibold text-[#3d2652]">
    {{ "mobile.eachat.wizard.delivery.selectionTitle" | translate }}
  </p>

  <div class="flex w-full min-w-0 flex-col gap-2.5">
    <button
      type="button"
      class="w-full rounded-xl border px-3 py-3 text-left text-sm leading-snug shadow-sm transition-colors active:bg-[#faf7fc]"
      [class.border-[#5a2f6b]]="wizardHost.isDeliveryModeSelected(wizardHost.DeliveryMode.DIRECT_TO_REQUESTER)"
      [class.bg-[#faf7fc]]="wizardHost.isDeliveryModeSelected(wizardHost.DeliveryMode.DIRECT_TO_REQUESTER)"
      [class.border-[#ece4f3]]="!wizardHost.isDeliveryModeSelected(wizardHost.DeliveryMode.DIRECT_TO_REQUESTER)"
      (click)="closeAgencyPicker(); wizardHost.setDeliveryMode(wizardHost.DeliveryMode.DIRECT_TO_REQUESTER)"
    >
      {{ "mobile.eachat.wizard.delivery.directRequester" | translate }}
    </button>
    <button
      type="button"
      class="w-full rounded-xl border px-3 py-3 text-left text-sm leading-snug shadow-sm transition-colors active:bg-[#faf7fc]"
      [class.border-[#5a2f6b]]="wizardHost.isDeliveryModeSelected(wizardHost.DeliveryMode.DIRECT_TO_RECIPIENT)"
      [class.bg-[#faf7fc]]="wizardHost.isDeliveryModeSelected(wizardHost.DeliveryMode.DIRECT_TO_RECIPIENT)"
      [class.border-[#ece4f3]]="!wizardHost.isDeliveryModeSelected(wizardHost.DeliveryMode.DIRECT_TO_RECIPIENT)"
      (click)="closeAgencyPicker(); wizardHost.setDeliveryMode(wizardHost.DeliveryMode.DIRECT_TO_RECIPIENT)"
    >
      {{ "mobile.eachat.wizard.delivery.directRecipient" | translate }}
    </button>
    <button
      type="button"
      class="w-full rounded-xl border px-3 py-3 text-left text-sm leading-snug shadow-sm transition-colors active:bg-[#faf7fc]"
      [class.border-[#5a2f6b]]="wizardHost.isDeliveryModeSelected(wizardHost.DeliveryMode.SPECIFIED_AGENCY)"
      [class.bg-[#faf7fc]]="wizardHost.isDeliveryModeSelected(wizardHost.DeliveryMode.SPECIFIED_AGENCY)"
      [class.border-[#ece4f3]]="!wizardHost.isDeliveryModeSelected(wizardHost.DeliveryMode.SPECIFIED_AGENCY)"
      (click)="selectAgencyDeliveryMode()"
    >
      {{ "mobile.eachat.wizard.delivery.specifiedAgency" | translate }}
    </button>

    @if (ticketInfo.Delivery?.LvfDeliveryMode === wizardHost.DeliveryMode.SPECIFIED_AGENCY) {
      <div
        #agencyDropdownRoot
        class="flex w-full min-w-0 flex-col gap-2 border-l-[3px] border-[#5a2f6b]/35 pl-3"
      >
        <label class="text-sm font-semibold text-[#3d2652]" for="agencyPickerTrigger">{{
          "mobile.eachat.wizard.delivery.selectAgencyLabel" | translate
        }}</label>
        <button
          type="button"
          id="agencyPickerTrigger"
          class="flex min-h-[44px] w-full min-w-0 items-center gap-2 rounded-full border border-[#1f1f1f]/22 bg-white px-4 py-2.5 text-left text-sm shadow-none transition-colors active:bg-[#faf7fc]"
          [class.ring-2]="agencyPickerOpen()"
          [class.ring-[#5a2f6b]]="agencyPickerOpen()"
          [attr.aria-expanded]="agencyPickerOpen()"
          aria-haspopup="listbox"
          (click)="toggleAgencyDropdown()"
        >
          @if (((wizardHost.deliverySelectedAgency()?.Name ?? "").trim()).length > 0) {
            <span class="min-w-0 flex-1 truncate text-left text-[#6b6b6b]">{{
              (wizardHost.deliverySelectedAgency()?.Name ?? "").trim()
            }}</span>
          } @else {
            <span class="min-w-0 flex-1 truncate text-left text-[#9a929e]">{{
              "mobile.eachat.wizard.delivery.agencyPlaceholder" | translate
            }}</span>
          }
          <span
            class="material-icons shrink-0 text-[22px] text-[#1a1523] transition-transform duration-150"
            [class.-rotate-180]="agencyPickerOpen()"
            aria-hidden="true"
            >expand_more</span
          >
        </button>

        @if (agencyPickerOpen()) {
          <div
            class="flex max-h-[min(50vh,21rem)] min-w-0 flex-col overflow-hidden rounded-xl border border-[#cfd1dc] bg-white shadow-sm"
            role="listbox"
            [attr.aria-label]="'mobile.eachat.wizard.delivery.agencyPickerTitle' | translate"
          >
            <div class="shrink-0 border-b border-[#ececec] p-2">
              <input
                type="search"
                name="deliveryAgencyInlineSearch"
                class="min-h-[40px] w-full rounded-full border border-[#d8d8d8] bg-white px-3 py-2 text-sm text-[#1a1523]"
                [placeholder]="'app.shared.search' | translate"
                [ngModel]="wizardHost.deliveryAgencySearchSig()"
                (ngModelChange)="wizardHost.onDeliveryAgencySearchChange($event)"
                [ngModelOptions]="{ standalone: true }"
                autocomplete="off"
                (click)="$event.stopPropagation()"
              />
            </div>
            <div class="min-h-0 flex-1 overflow-y-auto overscroll-contain px-1 py-1">
              @if (wizardHost.deliveryAgencyLoading()) {
                <div class="flex justify-center py-8">
                  <span class="material-icons animate-spin text-[#5a2f6b]" aria-hidden="true">progress_activity</span>
                </div>
              }
              @if (!wizardHost.deliveryAgencyLoading() && !wizardHost.deliveryAgenciesCatalog().length) {
                <p class="px-3 py-6 text-center text-sm text-[#7a6b8a]">
                  {{ "mobile.eachat.wizard.delivery.agencyListEmpty" | translate }}
                </p>
              }
              @if (!wizardHost.deliveryAgencyLoading() && wizardHost.deliveryAgenciesCatalog().length) {
                <ul class="space-y-0.5 py-1" role="none">
                  @for (deliveryAgency of wizardHost.deliveryAgenciesCatalog(); track deliveryAgencyTrack($index, deliveryAgency)) {
                    @if (deliveryAgency.Uid != null) {
                      <li role="none">
                        <button
                          type="button"
                          role="option"
                          class="flex w-full min-w-0 items-center gap-2 rounded-lg px-3 py-3 text-left text-sm transition-colors active:bg-[#f5f0fa]"
                          [class.bg-[#eee6f5]]="wizardHost.isDeliveryAgencyRowSelected(deliveryAgency)"
                          (click)="pickAgencyAndClose(deliveryAgency)"
                        >
                          <span class="min-w-0 flex-1 font-medium text-[#1a1523]">{{ deliveryAgency.Name }}</span>
                          @if (wizardHost.isDeliveryAgencyRowSelected(deliveryAgency)) {
                            <span class="material-icons shrink-0 text-[20px] text-[#5a2f6b]" aria-hidden="true">check</span>
                          }
                        </button>
                      </li>
                    }
                  }
                </ul>
              }
            </div>
          </div>
        }
      </div>
    }

    <button
      type="button"
      class="w-full rounded-xl border px-3 py-3 text-left text-sm leading-snug shadow-sm transition-colors active:bg-[#faf7fc]"
      [class.border-[#5a2f6b]]="wizardHost.isDeliveryModeSelected(wizardHost.DeliveryMode.MANUAL_INPUT_ADDRESS)"
      [class.bg-[#faf7fc]]="wizardHost.isDeliveryModeSelected(wizardHost.DeliveryMode.MANUAL_INPUT_ADDRESS)"
      [class.border-[#ece4f3]]="!wizardHost.isDeliveryModeSelected(wizardHost.DeliveryMode.MANUAL_INPUT_ADDRESS)"
      (click)="closeAgencyPicker(); wizardHost.setDeliveryMode(wizardHost.DeliveryMode.MANUAL_INPUT_ADDRESS)"
    >
      {{ "mobile.eachat.wizard.delivery.manualAddress" | translate }}
    </button>
  </div>

  @if (
    ticketInfo.Delivery?.LvfDeliveryMode != null &&
    ticketInfo.Delivery?.LvfDeliveryMode !== wizardHost.DeliveryMode.MANUAL_INPUT_ADDRESS
  ) {
    @let resolvedAddress = ticketInfo.Delivery?.EntityAddress;
    <div
      class="flex w-full min-w-0 flex-col gap-3 rounded-xl border border-[#ece4f3] bg-white p-3 shadow-sm"
      [attr.aria-label]="'app.shared.address' | translate"
    >
      <p class="text-sm font-semibold text-[#3d2652]">{{ "app.shared.address" | translate }}</p>
      @if (!wizardHost.previewDeliveryResolvedAddressLines().length) {
        @switch (ticketInfo.Delivery?.LvfDeliveryMode) {
          @case (wizardHost.DeliveryMode.DIRECT_TO_REQUESTER) {
            <p class="text-sm text-[#7a6b8a]">{{ "mobile.eachat.wizard.addressEmpty.requesterService" | translate }}</p>
          }
          @case (wizardHost.DeliveryMode.DIRECT_TO_RECIPIENT) {
            <p class="text-sm text-[#7a6b8a]">{{ "mobile.eachat.wizard.addressEmpty.recipientService" | translate }}</p>
          }
          @case (wizardHost.DeliveryMode.SPECIFIED_AGENCY) {
            <p class="text-sm text-[#7a6b8a]">{{ "mobile.eachat.wizard.addressEmpty.agencySite" | translate }}</p>
          }
          @default {
            <p class="text-sm text-[#7a6b8a]">{{ "mobile.eachat.wizard.addressEmptyHint" | translate }}</p>
          }
        }
      }
      <fieldset
        class="m-0 flex min-w-0 flex-col gap-3 border-0 p-0"
        [disabled]="true"
        [attr.aria-label]="'mobile.eachat.wizard.delivery.resolvedAddressReadonly' | translate"
      >
        <label class="flex min-w-0 flex-col gap-1">
          <span class="text-[0.7rem] font-semibold text-[#7a6b8a]">{{ "app.shared.streetnumber" | translate }}</span>
          <input
            type="text"
            name="resolvedStreetNumber"
            tabindex="-1"
            class="min-h-[44px] w-full rounded-xl border border-[#e2dde8] bg-[#ebe8f2] px-2 py-2 text-sm text-[#574f66]"
            [ngModel]="resolvedAddress?.StreetNumber ?? ''"
            [ngModelOptions]="{ standalone: true }"
          />
        </label>
        <label class="flex min-w-0 flex-col gap-1">
          <span class="text-[0.7rem] font-semibold text-[#7a6b8a]"
            >{{ "app.shared.streetname" | translate }} <span class="text-destructive">*</span></span
          >
          <input
            type="text"
            name="resolvedStreetName"
            tabindex="-1"
            class="min-h-[44px] w-full rounded-xl border border-[#e2dde8] bg-[#ebe8f2] px-2 py-2 text-sm text-[#574f66]"
            [ngModel]="resolvedAddress?.StreetName ?? ''"
            [ngModelOptions]="{ standalone: true }"
          />
        </label>
        <label class="flex min-w-0 flex-col gap-1">
          <span class="text-[0.7rem] font-semibold text-[#7a6b8a]">{{ "app.shared.furtherinformation" | translate }}</span>
          <input
            type="text"
            name="resolvedFurtherInformation"
            tabindex="-1"
            class="min-h-[44px] w-full rounded-xl border border-[#e2dde8] bg-[#ebe8f2] px-2 py-2 text-sm text-[#574f66]"
            [ngModel]="resolvedAddress?.FurtherInformation ?? ''"
            [ngModelOptions]="{ standalone: true }"
          />
        </label>
        <div class="grid w-full min-w-0 grid-cols-2 gap-2">
          <label class="flex min-w-0 flex-col gap-1">
            <span class="text-[0.7rem] font-semibold text-[#7a6b8a]"
              >{{ "app.shared.zipcode" | translate }} <span class="text-destructive">*</span></span
            >
            <input
              type="text"
              name="resolvedZipCode"
              tabindex="-1"
              class="min-h-[44px] w-full rounded-xl border border-[#e2dde8] bg-[#ebe8f2] px-2 py-2 text-sm text-[#574f66]"
              [ngModel]="resolvedAddress?.ZipCode ?? ''"
              [ngModelOptions]="{ standalone: true }"
            />
          </label>
          <label class="flex min-w-0 flex-col gap-1">
            <span class="text-[0.7rem] font-semibold text-[#7a6b8a]"
              >{{ "app.shared.city" | translate }} <span class="text-destructive">*</span></span
            >
            <input
              type="text"
              name="resolvedCity"
              tabindex="-1"
              class="min-h-[44px] w-full rounded-xl border border-[#e2dde8] bg-[#ebe8f2] px-2 py-2 text-sm text-[#574f66]"
              [ngModel]="resolvedAddress?.City ?? ''"
              [ngModelOptions]="{ standalone: true }"
            />
          </label>
        </div>
        <div class="flex min-w-0 flex-col gap-1">
          <span class="text-[0.7rem] font-semibold text-[#7a6b8a]"
            >{{ "app.shared.country" | translate }} <span class="text-destructive">*</span></span
          >
          <div class="flex w-full min-w-0 gap-2">
            <span
              class="flex h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-full border border-[#cfd1dc] bg-white shadow-sm"
              aria-hidden="true"
            >
              <img class="m-0 h-[19px] w-[30px] max-w-[30px] object-cover" [src]="deliveryCountryFlagSrc(resolvedAddress?.CountryCode)" alt="" />
            </span>
            <div
              class="pointer-events-none flex min-h-[44px] min-w-0 flex-1 items-center justify-between rounded-full border border-[#cfd1dc] bg-[#ebe8f2] px-3 text-sm text-[#7a7583]"
            >
              <span class="min-w-0 truncate">{{ resolvedAddress?.Country?.trim() || ("app.lvfcountry.france" | translate) }}</span>
              <span class="material-icons shrink-0 text-[22px] text-[#9a939e]" aria-hidden="true">expand_more</span>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
  }

  @if (ticketInfo.Delivery?.LvfDeliveryMode === wizardHost.DeliveryMode.MANUAL_INPUT_ADDRESS) {
    <div class="flex w-full min-w-0 flex-col gap-3 rounded-xl border border-[#ece4f3] bg-white p-3 shadow-sm">
      <p class="text-sm font-semibold text-[#3d2652]">{{ "app.shared.address" | translate }}</p>
      @if (wizardHost.deliveryManualAddress(); as manualAddress) {
        <label class="flex w-full min-w-0 flex-col gap-1">
          <span class="text-[0.7rem] font-semibold text-[#7a6b8a]">{{ "app.shared.streetnumber" | translate }}</span>
          <input
            type="text"
            maxlength="10"
            class="min-h-[44px] w-full rounded-xl border border-[#ece4f3] bg-[#faf7fc] px-2 py-2 text-sm"
            [ngModel]="manualAddress.StreetNumber ?? ''"
            (ngModelChange)="wizardHost.patchManualAddress({ StreetNumber: $event })"
            [ngModelOptions]="{ standalone: true }"
          />
        </label>
        <label class="flex w-full min-w-0 flex-col gap-1">
          <span class="text-[0.7rem] font-semibold text-[#7a6b8a]"
            >{{ "app.shared.streetname" | translate }} <span class="text-destructive">*</span></span
          >
          <input
            type="text"
            maxlength="50"
            class="min-h-[44px] w-full rounded-xl border border-[#ece4f3] bg-[#faf7fc] px-2 py-2 text-sm"
            [ngModel]="manualAddress.StreetName ?? ''"
            (ngModelChange)="wizardHost.patchManualAddress({ StreetName: $event })"
            [ngModelOptions]="{ standalone: true }"
          />
        </label>
        <label class="flex flex-col gap-1">
          <span class="text-[0.7rem] font-semibold text-[#7a6b8a]">{{ "app.shared.furtherinformation" | translate }}</span>
          <input
            type="text"
            maxlength="100"
            class="min-h-[44px] w-full rounded-xl border border-[#ece4f3] bg-[#faf7fc] px-2 py-2 text-sm"
            [ngModel]="manualAddress.FurtherInformation ?? ''"
            (ngModelChange)="wizardHost.patchManualAddress({ FurtherInformation: $event })"
            [ngModelOptions]="{ standalone: true }"
          />
        </label>
        <div class="grid w-full min-w-0 grid-cols-2 gap-2">
          <label class="flex flex-col gap-1">
            <span class="text-[0.7rem] font-semibold text-[#7a6b8a]"
              >{{ "app.shared.zipcode" | translate }} <span class="text-destructive">*</span></span
            >
            <input
              type="text"
              maxlength="10"
              class="min-h-[44px] w-full rounded-xl border border-[#ece4f3] bg-[#faf7fc] px-2 py-2 text-sm"
              [ngModel]="manualAddress.ZipCode ?? ''"
              (ngModelChange)="wizardHost.patchManualAddress({ ZipCode: $event })"
              [ngModelOptions]="{ standalone: true }"
            />
          </label>
          <label class="flex flex-col gap-1">
            <span class="text-[0.7rem] font-semibold text-[#7a6b8a]"
              >{{ "app.shared.city" | translate }} <span class="text-destructive">*</span></span
            >
            <input
              type="text"
              maxlength="80"
              class="min-h-[44px] w-full rounded-xl border border-[#ece4f3] bg-[#faf7fc] px-2 py-2 text-sm"
              [ngModel]="manualAddress.City ?? ''"
              (ngModelChange)="wizardHost.patchManualAddress({ City: $event })"
              [ngModelOptions]="{ standalone: true }"
            />
          </label>
        </div>
        <div class="flex w-full min-w-0 flex-col gap-1">
          <span class="text-[0.7rem] font-semibold text-[#7a6b8a]"
            >{{ "app.shared.country" | translate }} <span class="text-destructive">*</span></span
          >
          <div class="flex w-full min-w-0 gap-2">
            <span
              class="flex h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-full border border-[#ece4f3] bg-white shadow-sm"
              aria-hidden="true"
            >
              <img class="m-0 h-[19px] w-[30px] max-w-[30px] object-cover" [src]="deliveryCountryFlagSrc(manualAddress?.CountryCode)" alt="" />
            </span>
            <div
              class="pointer-events-none flex min-h-[44px] min-w-0 flex-1 cursor-not-allowed items-center justify-between rounded-full border border-[#ece4f3] bg-[#faf7fc] px-3 text-sm text-[#7a7583]"
              aria-readonly="true"
            >
              <span class="min-w-0 truncate">{{ "app.lvfcountry.france" | translate }}</span>
              <span class="material-icons shrink-0 text-[22px] text-[#9a929e]" aria-hidden="true">expand_more</span>
            </div>
          </div>
        </div>
      }
    </div>
  }

  @if (wizardHost.deliveryAddressIncompleteTouched()) {
    <p class="text-sm text-destructive">{{ "mobile.eachat.wizard.addressIncomplete" | translate }}</p>
  }

